<form
  class="space-y-3"
  [formGroup]="form">
  <div class="bg-bg-surface-default space-y-5 rounded-xl p-8">
    <div class="pb-2">
      <h1 class="text-text-default text-lg font-bold">Data Diri Karyawan</h1>
      <p class="text-text-subtler text-sm">Ketik informasi dasar mengenai identitas karyawan.</p>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Foto Profil</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
        <p class="text-text-subtler text-xs">
          Bisa di skip, tapi jangan lupa minta fotoin Ganang untuk karyawan ini
        </p>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-image
            class="block"
            formControlName="image"
            boxStyleClass="border-solid !bg-bg-surface-default"
            label="Upload Foto"
            (remove)="form.controls.image.setValue('')"
            (ngModelChange)="formService.resetError(formError, 'image')" />
          @if (formError.image.msg) {
            <p class="text-text-error text-xs">{{ formError.image.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Nama Lengkap</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="name"
            placeholder="Ketik Nama Lengkap"
            (ngModelChange)="formService.resetError(formError, 'name')" />
          @if (formError.name.msg) {
            <p class="text-text-error text-xs">{{ formError.name.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Nama Panggilan</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
        <p class="text-text-subtler text-xs">Misal “Muhidin Jafar” pangilannya “Ibenk”</p>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="nickname"
            placeholder="Ketik Nama Panggilan"
            (ngModelChange)="formService.resetError(formError, 'nickname')" />
          @if (formError.nickname.msg) {
            <p class="text-text-error text-xs">{{ formError.nickname.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Kewarganegaraan</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-button
            class="block"
            theme="outline"
            styleClass="justify-start gap-3 !font-normal"
            [disabled]="true">
            <img
              class="border-line-default h-4 w-6 rounded border object-cover"
              src="/assets/images/flag/id.svg" />
            <span> Indonesia </span>
          </app-button>
          @if (formError.nationality.msg) {
            <p class="text-text-error text-xs">{{ formError.nationality.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Tanggal Lahir</p>
      <div class="col-span-2 space-y-2">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="place_of_birth"
            placeholder="Ketik Tempat Lahir"
            (ngModelChange)="formService.resetError(formError, 'place_of_birth')" />
          @if (formError.place_of_birth.msg) {
            <p class="text-text-error text-xs">{{ formError.place_of_birth.msg }}</p>
          }
        </div>
        <div class="space-y-1">
          <app-input-date
            class="block"
            formControlName="birthday"
            placeholder="Pilih Tanggal Lahir"
            dateFormat="dd MMM y"
            defaultValue="2000-01-01"
            (ngModelChange)="formService.resetError(formError, 'birthday')">
            @if (form.value.birthday) {
              <div
                template="suffix"
                class="shrink-0 p-2">
                <p class="bg-alpha-on-surface text-text-subtler rounded-xl px-1.5 text-xs">
                  {{ form.value.birthday | diffYear }}
                </p>
              </div>
            }
          </app-input-date>
          @if (formError.birthday.msg) {
            <p class="text-text-error text-xs">{{ formError.birthday.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">No. ID/KTP</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-number
            class="block"
            formControlName="identity_number"
            placeholder="Ketik No. ID/KTP"
            [useGrouping]="false"
            (ngModelChange)="formService.resetError(formError, 'identity_number')" />
          @if (formError.identity_number.msg) {
            <p class="text-text-error text-xs">{{ formError.identity_number.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Agama</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-radio
            class="block"
            mode="simple"
            [options]="religionOptions"
            formControlName="religion"
            (ngModelChange)="formService.resetError(formError, 'religion')" />
          @if (formError.religion.msg) {
            <p class="text-text-error text-xs">{{ formError.religion.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Jenis Kelamin</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-radio
            class="block"
            mode="simple"
            [options]="genderOptions"
            formControlName="gender"
            (ngModelChange)="formService.resetError(formError, 'gender')" />
          @if (formError.gender.msg) {
            <p class="text-text-error text-xs">{{ formError.gender.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Alamat KTP</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-textarea
            class="block"
            formControlName="address_original"
            placeholder="Ketik Alamat Sesuai KTP"
            [rows]="5"
            (ngModelChange)="formService.resetError(formError, 'address_original')" />
          @if (formError.address_original.msg) {
            <p class="text-text-error text-xs">{{ formError.address_original.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Rekening Bank</p>
      <div
        formArrayName="banks"
        class="col-span-2 space-y-3">
        @for (bank of form.controls.banks.controls; track bank) {
          <div
            [formGroupName]="$index"
            class="border-line-default rounded-xl border">
            <div class="flex items-center gap-3 p-4">
              <p class="text-text-default grow text-lg font-bold">
                Data Nomor Rekening #{{ $index + 1 }}
              </p>
              <app-button
                theme="outline"
                class="block shrink-0"
                styleClass="gap-2 items-center"
                (click)="_toggleBankPrimary($index)">
                Jadikan Utama
                <app-checkbox-toggle
                  class="block"
                  [checked]="bank.value.is_primary === 'true'" />
              </app-button>
              @if (form.controls.banks.length > 1) {
                <app-button
                  theme="outline"
                  [icon]="true"
                  (click)="_removeBank($index)">
                  <ic-trash-outline class="block h-4 w-4" />
                </app-button>
              }
            </div>
            <div class="border-line-default space-y-3 border-t p-4">
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">Nama Bank</p>
                <div class="space-y-1">
                  <app-input-select
                    class="block"
                    formControlName="bank_name"
                    placeholder="Pilih Bank"
                    [options]="bankOptions"
                    (ngModelChange)="
                      formService.resetError(formError.banks[$index], 'bank_name')
                    " />
                  @if (formError.banks[$index].bank_name.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.banks[$index].bank_name.msg }}
                    </p>
                  }
                </div>
              </div>
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">Nomor Rekening</p>
                <div class="space-y-1">
                  <app-input-text
                    class="block"
                    formControlName="account_number"
                    placeholder="Ketik Nomor Rekening"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    (ngModelChange)="
                      formService.resetError(formError.banks[$index], 'account_number')
                    " />
                  @if (formError.banks[$index].account_number.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.banks[$index].account_number.msg }}
                    </p>
                  }
                </div>
              </div>
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">Nama Pemilik Rekening</p>
                <div class="space-y-1">
                  <app-input-text
                    class="block"
                    formControlName="account_name"
                    placeholder="Ketik Nama Pemilik Rekening"
                    (ngModelChange)="
                      formService.resetError(formError.banks[$index], 'account_name')
                    " />
                  @if (formError.banks[$index].account_name.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.banks[$index].account_name.msg }}
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <app-button
          theme="tint-brand"
          (click)="addBank.emit()">
          <ic-plus-outline class="block h-4 w-4" />
          Tambah Data
        </app-button>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Golongan Darah</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-radio
            class="block"
            mode="simple"
            [options]="bloodTypeOptions"
            formControlName="blood_type"
            (ngModelChange)="formService.resetError(formError, 'blood_type')" />
          @if (formError.blood_type.msg) {
            <p class="text-text-error text-xs">{{ formError.blood_type.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">No. NPWP</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-number
            class="block"
            formControlName="npwp_number"
            placeholder="Ketik No. ID/KTP"
            [useGrouping]="false"
            (ngModelChange)="formService.resetError(formError, 'npwp_number')" />
          @if (formError.npwp_number.msg) {
            <p class="text-text-error text-xs">{{ formError.npwp_number.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Foto NPWP</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-image
            class="block"
            formControlName="npwp_image"
            boxStyleClass="border-solid !bg-bg-surface-default"
            label="Upload Foto"
            (remove)="form.controls.npwp_image.setValue('')"
            (preview)="globalService.showImagePreview($event)"
            (ngModelChange)="formService.resetError(formError, 'npwp_image')" />
          @if (formError.npwp_image.msg) {
            <p class="text-text-error text-xs">{{ formError.npwp_image.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Foto ID/KTP</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-image
            class="block"
            formControlName="ktp_image"
            boxStyleClass="border-solid !bg-bg-surface-default"
            label="Upload Foto"
            (remove)="form.controls.ktp_image.setValue('')"
            (preview)="globalService.showImagePreview($event)"
            (ngModelChange)="formService.resetError(formError, 'ktp_image')" />
          @if (formError.ktp_image.msg) {
            <p class="text-text-error text-xs">{{ formError.ktp_image.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Nama Faskes</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
        <p class="text-text-subtler text-xs">Data kepesertaan BPJS Kesehatan.</p>
      </div>
      <div class="col-span-2 space-y-4">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="nama_faskes"
            placeholder="Ketik Nama Faskes"
            (ngModelChange)="formService.resetError(formError, 'nama_faskes')" />
          @if (formError.nama_faskes.msg) {
            <p class="text-text-error text-xs">{{ formError.nama_faskes.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Kode Faskes</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
        <p class="text-text-subtler text-xs">Data kepesertaan BPJS Kesehatan.</p>
      </div>
      <div class="col-span-2 space-y-4">
        <div class="space-y-1">
          <app-input-text
            class="block"
            formControlName="kode_faskes"
            placeholder="Ketik Kode Faskes"
            (ngModelChange)="formService.resetError(formError, 'kode_faskes')" />
          @if (formError.kode_faskes.msg) {
            <p class="text-text-error text-xs">{{ formError.kode_faskes.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Kontak Darurat</p>
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
      </div>
      <div
        formArrayName="kontak_darurat"
        class="col-span-2 space-y-3">
        @for (kontak_darurat of form.controls.kontak_darurat.controls; track kontak_darurat) {
          <div
            [formGroupName]="$index"
            class="border-line-default rounded-xl border">
            <div class="flex items-center p-4">
              <p class="text-text-default grow text-lg font-bold">
                Data Kontak Darurat #{{ $index + 1 }}
              </p>
              @if (form.controls.kontak_darurat.length > 1) {
                <app-button
                  theme="outline"
                  [icon]="true"
                  (click)="removeKontakDarurat.emit($index)">
                  <ic-trash-outline class="block h-4 w-4" />
                </app-button>
              }
            </div>
            <div class="border-line-default space-y-3 border-t p-4">
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">Nama</p>
                <div class="space-y-1">
                  <app-input-text
                    class="block"
                    formControlName="name"
                    placeholder="Ketik Nama"
                    (ngModelChange)="
                      formService.resetError(formError.kontak_darurat[$index], 'name')
                    " />
                  @if (formError.kontak_darurat[$index].name.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.kontak_darurat[$index].name.msg }}
                    </p>
                  }
                </div>
              </div>
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">No. Telepon</p>
                <div class="flex gap-2">
                  <div class="space-y-1">
                    <app-input-phone-ext
                      class="block w-32"
                      formControlName="phone_ext"
                      (ngModelChange)="
                        formService.resetError(formError.kontak_darurat[$index], 'phone_ext')
                      " />
                    @if (formError.kontak_darurat[$index].phone_ext.msg) {
                      <p class="text-text-error text-xs">
                        {{ formError.kontak_darurat[$index].phone_ext.msg }}
                      </p>
                    }
                  </div>
                  <div class="grow space-y-1">
                    <app-input-number
                      class="block"
                      formControlName="phone"
                      placeholder="Ketik No. Telepon"
                      [useGrouping]="false"
                      (ngModelChange)="
                        formService.resetError(formError.kontak_darurat[$index], 'phone')
                      " />
                    @if (formError.kontak_darurat[$index].phone.msg) {
                      <p class="text-text-error text-xs">
                        {{ formError.kontak_darurat[$index].phone.msg }}
                      </p>
                    }
                  </div>
                </div>
              </div>
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">Alamat</p>
                <div class="space-y-1">
                  <app-input-textarea
                    class="block"
                    formControlName="address"
                    placeholder="Ketik Alamat"
                    (ngModelChange)="
                      formService.resetError(formError.kontak_darurat[$index], 'address')
                    " />
                  @if (formError.kontak_darurat[$index].address.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.kontak_darurat[$index].address.msg }}
                    </p>
                  }
                </div>
              </div>
              <div class="space-y-1.5">
                <p class="text-text-subtle text-xs font-semibold">
                  Hubungan dengan Karyawan Sebagai
                </p>
                <div class="space-y-1">
                  <app-input-radio
                    class="block"
                    mode="simple"
                    styleClass="flex w-max gap-3"
                    [options]="relationOption"
                    [(ngModel)]="relationSelected[$index]"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="_changeRelation($event, $index)" />
                  @if (relationSelected[$index] === "Lainnya") {
                    <app-input-text
                      class="block"
                      formControlName="relation"
                      placeholder="Masukkan hubungan dengan karyawan"
                      (ngModelChange)="
                        formService.resetError(formError.kontak_darurat[$index], 'relation')
                      " />
                  }
                  @if (formError.kontak_darurat[$index].relation.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.kontak_darurat[$index].relation.msg }}
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <app-button
          theme="tint-brand"
          (click)="addKontakDarurat.emit()">
          <ic-plus-outline class="block h-4 w-4" />
          Tambah Data
        </app-button>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Data Fisik</p>
        </div>
      </div>
      <div class="col-span-2 space-y-6">
        <div class="border-line-default rounded-xl border">
          <div class="flex items-center p-4">
            <p class="text-text-default grow text-lg font-bold">Data Fisik</p>
          </div>
          <div class="border-line-default space-y-3 border-t p-4">
            <div class="space-y-1.5">
              <div class="flex items-center gap-1">
                <p class="text-text-subtle text-xs font-semibold">Berat Badan</p>
                <p
                  class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
                  Opsional
                </p>
              </div>
              <div class="space-y-1">
                <app-input-number
                  class="block"
                  formControlName="weight"
                  placeholder="Contoh: 65"
                  [useGrouping]="false"
                  (ngModelChange)="formService.resetError(formError, 'weight')">
                  <div
                    template="suffix"
                    class="flex aspect-square h-full items-center justify-center">
                    <div class="text-text-subtler text-xs font-medium">Kg</div>
                  </div>
                </app-input-number>
                @if (formError.weight.msg) {
                  <p class="text-text-error text-xs">{{ formError.weight.msg }}</p>
                }
              </div>
            </div>
            <div class="space-y-1.5">
              <div class="flex items-center gap-1">
                <p class="text-text-subtle text-xs font-semibold">Tinggi Badan</p>
                <p
                  class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
                  Opsional
                </p>
              </div>
              <div class="space-y-1">
                <app-input-number
                  class="block"
                  formControlName="height"
                  placeholder="Contoh: 170"
                  [useGrouping]="false"
                  (ngModelChange)="formService.resetError(formError, 'height')">
                  <div
                    template="suffix"
                    class="flex aspect-square h-full items-center justify-center">
                    <div class="text-text-subtler text-xs font-medium">Cm</div>
                  </div>
                </app-input-number>
                @if (formError.height.msg) {
                  <p class="text-text-error text-xs">{{ formError.height.msg }}</p>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="border-line-default rounded-xl border">
          <div class="flex items-center p-4">
            <p class="text-text-default grow text-lg font-bold">Ukuran Pakaian & Sepatu</p>
          </div>
          <div class="border-line-default space-y-3 border-t p-4">
            <div class="space-y-1.5">
              <div class="flex items-center gap-1">
                <p class="text-text-subtle text-xs font-semibold">Ukuran Baju</p>
                <p
                  class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
                  Opsional
                </p>
              </div>
              <div class="space-y-1">
                <app-input-select
                  class="block"
                  formControlName="shirt_size"
                  placeholder="Pilih Ukuran Baju"
                  [options]="shirtSizeOptions"
                  (ngModelChange)="formService.resetError(formError, 'shirt_size')" />
                @if (formError.shirt_size.msg) {
                  <p class="text-text-error text-xs">
                    {{ formError.shirt_size.msg }}
                  </p>
                }
              </div>
            </div>
            <div class="space-y-1.5">
              <div class="flex items-center gap-1">
                <p class="text-text-subtle text-xs font-semibold">Ukuran Celana</p>
                <p
                  class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
                  Opsional
                </p>
              </div>
              <div class="space-y-1">
                <app-input-number
                  class="block"
                  formControlName="pants_size"
                  placeholder="Contoh: 28"
                  [useGrouping]="false"
                  (ngModelChange)="formService.resetError(formError, 'pants_size')" />
                @if (formError.pants_size.msg) {
                  <p class="text-text-error text-xs">{{ formError.pants_size.msg }}</p>
                }
              </div>
            </div>
            <div class="space-y-1.5">
              <div class="flex items-center gap-1">
                <p class="text-text-subtle text-xs font-semibold">Ukuran Sepatu</p>
                <p
                  class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
                  Opsional
                </p>
              </div>
              <div class="space-y-1">
                <app-input-select
                  class="block"
                  formControlName="shoe_size"
                  placeholder="Pilih Ukuran Sepatu"
                  [options]="shoeSizeOptions"
                  (ngModelChange)="formService.resetError(formError, 'shoe_size')" />
                @if (formError.shoe_size.msg) {
                  <p class="text-text-error text-xs">
                    {{ formError.shoe_size.msg }}
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <div class="flex items-center gap-1">
          <p class="text-text-default text-sm font-semibold">Riwayat Sakit</p>
        </div>
      </div>
      <div class="col-span-2 space-y-2">
        <div class="flex items-center gap-1">
          <p class="text-text-subtle bg-alpha-on-surface rounded-xl px-1.5 text-[10px] font-medium">
            Opsional
          </p>
        </div>
        <div class="space-y-1">
          <app-input-radio
            class="block"
            styleClass="!p-0 h-10 w-80! !gap-0"
            dividerStyleClass="!p-0"
            radioBoxStyleClass="pl-2 pr-4"
            [options]="hasMedicalHistoryOptions"
            formControlName="has_medical_history"
            (ngModelChange)="_onHasMedicalHistoryChange()" />
          @if (formError.has_medical_history.msg) {
            <p class="text-text-error text-xs">{{ formError.has_medical_history.msg }}</p>
          }
        </div>
        @if (form.controls.medical_history.hasValidator(Validators.required)) {
          <div class="space-y-1">
            <app-input-text
              class="block"
              formControlName="medical_history"
              placeholder="Contoh: Asma, Diabetes, atau Lainnya"
              (ngModelChange)="formService.resetError(formError, 'medical_history')" />
            @if (formError.medical_history.msg) {
              <p class="text-text-error text-xs">{{ formError.medical_history.msg }}</p>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <app-button
    class="ml-auto block w-32"
    (click)="_next()">
    Selanjutnya
  </app-button>
</form>
